import { Channel } from '@/Enums/Channel.enum';
import ClearAllButton from '@/components/Buttons/ClearAllButton';
import { DURATION_OPTIONS } from '@/constants/forecaster';
import { ExpandMore, Schedule } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  accordionSummaryClasses,
  styled,
} from '@mui/material';
import { useCallback, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

const ControlLabel = styled(FormControlLabel)(({ theme }) => ({
  border: '1px solid rgba(0, 0, 0, 0.2)',
  margin: 0,
  borderRadius: theme.shape.borderRadius,
  paddingRight: '9px',
  color: theme.palette.primary.main,
  ':hover': {
    background: theme.palette.action.hover,
  },
}));

interface IProps {
  currentChannel: Channel;
}

const Duration = ({ currentChannel }: IProps) => {
  const controlName = useMemo(() => `${currentChannel}.duration`, [currentChannel]);
  const { control, resetField } = useFormContext();

  const onResetClick = useCallback(() => resetField(controlName), [resetField, controlName]);

  return (
    <Paper className='rounded-lg'>
      <Accordion>
        <AccordionSummary
          sx={{
            [`& .${accordionSummaryClasses.content}`]: {
              alignItems: 'center',
            },
          }}
          expandIcon={<ExpandMore />}
          aria-controls='duration-content'
          id='duration-header'
        >
          <Schedule sx={{ marginRight: 1 }} />
          <span className='text-lg font-semibold'>Duration</span>
        </AccordionSummary>
        <AccordionDetails sx={{ display: 'flex', gap: 2 }}>
          <Controller
            control={control}
            name={controlName}
            render={({ field }) => (
              <RadioGroup {...field} row sx={{ gap: 2 }} aria-labelledby='duration-header'>
                {DURATION_OPTIONS.map((option, i) => (
                  <ControlLabel key={i} control={<Radio value={option.value} key={i} disableRipple />} {...option} />
                ))}
              </RadioGroup>
            )}
          />
          <ClearAllButton onClick={onResetClick} label='Clear' />
        </AccordionDetails>
      </Accordion>
    </Paper>
  );
};

export default Duration;
